import { FC } from 'react'

export const MiFooter: FC = () => {
  return (
    <footer className="text-lg-start bg-light text-muted miFooter">
      <div className="footer-item">
        <a href="https://hi.helloproteger.com/terms-of-service/" target="_blank" rel="noreferrer">
          利用規約（自然故障対応）
        </a>
      </div>
      <div className="footer-item">
        <a href="https://hi.helloproteger.com/terms-of-service-adh/" target="_blank" rel="noreferrer">
          利用規約（物損故障対応）
        </a>
      </div>
      <div className="footer-item">
        <a href="https://hi.helloproteger.com/privacy-policy/" target="_blank" rel="noreferrer">
          プライバシーポリシー
        </a>
      </div>
      <div className="footer-item">
        <a href="https://hi.helloproteger.com/privacy/" target="_blank" rel="noreferrer">
          個人情報保護方針
        </a>
      </div>
      <div className="footer-item">
        <a href="https://hi.helloproteger.com/security/" target="_blank" rel="noreferrer">
          情報セキュリティ方針
        </a>
      </div>
      <div className="footer-copyright text-center py-3">
        All rights reserved 2023 © <a href="https://hi.helloproteger.com/">kiva corp</a>
      </div>
    </footer>
  )
}
